const platform = {
    title: 'Definições da plataforma',
    subtitle: 'Gira administradores entre inquilinos e o aspeto global.',
    branding_title: 'Marca da plataforma',
    branding_description: 'Aplicada à consola, autenticação, centro de contas, demonstrações e ajuda.',
    product_name: 'Nome do produto',
    slogan: 'Slogan',
    light_logo: 'Logótipo do tema claro',
    dark_logo: 'Logótipo do tema escuro',
    upload_logo: 'Carregar logótipo',
    uploading: 'A carregar…',
    logo_uploaded: 'Logótipo carregado',
    hide_open_source_notice: 'Ocultar aviso de código aberto',
    hide_open_source_notice_description: 'Oculta ligações visíveis de atribuição e mantém os ficheiros de licença e código-fonte.',
    save: 'Guardar alterações',
    saving: 'A guardar…',
    saved: 'Marca da plataforma guardada',
    administrators_title: 'Administradores da plataforma',
    administrators_description: 'Podem gerir todos os inquilinos e definições da instância.',
    administrator_identifier_placeholder: 'ID, nome de utilizador ou e-mail',
    add_administrator: 'Adicionar administrador',
    administrator_added: 'Administrador adicionado',
    remove_administrator: 'Remover administrador',
};
export default Object.freeze(platform);
